require("core-js/modules/es.date.to-string.js");

var isSameHour = require('../is_same_hour/index.js');
/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */


function isThisHour(dirtyDate) {
  return isSameHour(new Date(), dirtyDate);
}

module.exports = isThisHour;